/**
 * @author David Roman <david@inarix.com>
 * @file Layout Reducer
 * @desc Created on 2020-12-11 1:40:51 pm
 * @copyright Inarix
 */

import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { deleteUserFromGroup } from "../actions/users/userAsyncActions";
import { RootState } from "../../configureStore";

// TODO add more in here
export type SectionName =
  | "/"
  | "/dashboard"
  | "/users"
  | "/devices"
  | "/locations"
  | "/licenses"
  | "/actions"
  | "/data"
  | "/projects"
  | "/actionView";

export type LocalizedTextsCodes = {
  code: number;
  values: string;
};

export interface LayoutState {
  sectionName: SectionName;
  locale: string;
  poperAccount: boolean;
  layoutActive: boolean;
  anchorEl: boolean;
  confirmModal: boolean;
  infoConfirmModal: any;
  localizedTextsCodes: { [key: string]: number };
}

export const selectLocale = (state: RootState) => state.LayoutReducer.locale;

export const initialState: LayoutState = {
  sectionName: "/",
  locale: "fr",
  poperAccount: false,
  layoutActive: false,
  anchorEl: false,
  confirmModal: false,
  infoConfirmModal: undefined,
  localizedTextsCodes: {
    en: 12,
    fr: 13,
    de: 38,
    es: 39,
    bg: 46,
    ro: 47,
    it: 48,
  },
};

export const logOut = createAction("REVERT_ALL");

export const LayoutSlice = createSlice({
  name: "LayoutReducer",
  initialState,
  reducers: {
    setInfoConfirmModal(state, action) {
      state.infoConfirmModal = action.payload;
    },
    setConfirmModal(state, action) {
      state.confirmModal = action.payload;
    },
    setAnchorEl(state, action) {
      state.anchorEl = action.payload;
    },
    setVisible(state, action) {
      return {
        ...state,
        layoutActive: action.payload,
      };
    },

    setTabNameLayout(state, action: PayloadAction<SectionName>) {
      state.sectionName = action.payload;
    },

    setLocale(state, action) {
      state.locale = action.payload;
    },
    disableTabNameLayout(state) {
      state.sectionName = "/";
    },

    layoutLogout() {
      return initialState;
    },
  },

  extraReducers(builder) {
    builder
      .addCase(deleteUserFromGroup.fulfilled, (state) => {
        state.confirmModal = false;
      })
      .addCase(deleteUserFromGroup.rejected, (state) => {
        state.confirmModal = false;
      });

    builder.addCase(logOut, () => {
      return initialState;
    });
  },
});

export const {
  setAnchorEl,
  setVisible,
  setTabNameLayout,
  setLocale,
  disableTabNameLayout,
  layoutLogout,
  setConfirmModal,
  setInfoConfirmModal,
} = LayoutSlice.actions;

export const layout = LayoutSlice.reducer;
